import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";

const SettlementRow = ({ rowData, index }) => {
  return (
    <tr className={`border-b border-neutral-200 transition-colors hover:bg-neutral-30 `}>
      <td className="px-3 py-2 text-center text-neutral-700">{rowData.settlement.amount.toLocaleString()}</td>
      <td className="px-3 py-2 text-center ">
        <div
          className={` items-center min-w-32 text-center  ${
            rowData.settlement.paid
              ? "bg-success-10 text-success-90 text-center"
              : "bg-yellow-100 text-yellow-700 text-center"
          }`}
        >
          {rowData.settlement.paid ? "پرداخت شده" : "در انتظار پرداخت"}
        </div>
      </td>

      <td className="px-3 py-2 text-center text-neutral-700">
        {new DateObject({
          date: rowData.settlement.creation_time * 1000,
          calendar: persian,
        }).format("YYYY/MM/DD")}
      </td>
      <td className="px-3 py-2 text-center text-neutral-700">
        {new DateObject({
          date: rowData.settlement.payment_time * 1000,
          calendar: persian,
        }).format("YYYY/MM/DD")}
      </td>

      <td className="px-3 py-2 text-center text-neutral-700 min-w-40">{rowData.settlement.owner ?? "-"}</td>
      <td className="px-3 py-2 text-center text-neutral-700">{rowData.settlement.iban ?? "-"}</td>
      <td className="px-3 py-2 text-center text-neutral-700">{rowData.settlement.tracking_number ?? "-"}</td>
    </tr>
  );
};

export default SettlementRow;
